import { Injectable, signal } from '@angular/core';
import { logger } from 'src/app/utils';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private _isLoadingSignal = signal<boolean>(false);
  readonly isLoading = this._isLoadingSignal.asReadonly();

  private activeRequests = 0;

  hide() {
    logger.i('hide loader');
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0) {
      this._isLoadingSignal.set(false);
    }
  }

  show() {
    logger.i('show loader');
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this._isLoadingSignal.set(true);
    }
  }
}
